import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import {
  Badge,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Button, Modal, Col, Spinner, ModalBody, ModalFooter,
  FormGroup, Label, Input, NavLink
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import decodeJwt from 'jwt-decode';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Multiselect from 'multiselect-react-dropdown';

export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(apiData, fileName)} style={{ padding: 6, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
  );
};

const Technicians = (props) => {
  const history = useHistory();
  const [technicians, setTechnicians] = useState();
  const [category, setCategory] = useState();
  const [open, setOpen] = React.useState(false);
  const [pos, setPos] = useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption_update, setSelectedOption_update] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [searchterm, setSearchTerm] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [peropen, setPeropen] = useState(false)
  const [exported, setExported] = useState([]);
  const [filter, setFilter] = useState(false);
  const [searchcategory, setSearchcategory] = useState(false);
  const [editcatval, setEditcatval] = useState([]);
  const [editcategory, setEditcategory] = useState([]);
  const [catresult, setCatresult] = useState([]);
  const [catemptyOpen, setCatemptyopen] = useState(false);



  const onLogout = () => {
    auth.logout();
    history.push("/")
  }

  const handleClickOpen = (index) => {
    setPos(index)
    setEditcatval(technicians[index]?.category.map((cat, index) => ({ name: cat?.category, value: cat?.id })));
    // setSelectedOption_update(category[index].category);
    setOpen(true);
  };

  const onChangeSelection_update = (e) => {
    setSelectedOption_update(e);
  }
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };

  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('category', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setEditcategory(data.map((cat, index) => ({ name: cat?.category, value: cat?.id })));
        setCategory(data);
      })
    dataProvider.getList('technicians', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({
            id: item.id, FullName: item.fullname, Email: item.email, Mobile: item.phone,
            Category: getCategory(item?.category),
            // Category: item.category[0].category
          }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setTechnicians(data);
        setSearchTerm('')
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }, [props, reload]);

  const onSubmit = (values, id) => {
    if (catresult && catresult.length === 0) {
      setCatemptyopen(true)
      return;
    }
    setOpen(false);
    dataProvider.update('technicians', { id: technicians[pos]?.id, params: { ...values, category: catresult } })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => setSucess(false), 1000);
        history.push("/technicians")
      })
      .catch(error => {
        setLoading(false)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  };

  const removeData = (id, index) => {
    dataProvider.delete('technicians', { id: id });
    let userArr = technicians;
    userArr.splice(index, 1);
    setTechnicians(userArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const searchFilter = () => {
    setPage(1);
    setReload(!reload);
  }
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  let per = localStorage.getItem('permission');
  // let token = localStorage.getItem('token');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const onSubmitFilterkey = () => {

  }
  const handleKeyPress = (event) => {
    let token = localStorage.getItem('token');
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    dataProvider.getList('technicians', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        setTechnicians(data)
      }).catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }
  const onSubmitFilter = values => {
  }
  const onFilterQuery = () => {
    let token = localStorage.getItem('token');
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    if (searchcategory) {
      filter.category = searchcategory;
    }
    // let filter = searchterm ? { fullname: searchterm } : false
    dataProvider.getList('technicians', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({ id: item.id, FullName: item.fullname, Email: item.email, Mobile: item.phone, Category: item.category.category }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setTechnicians(data);
        setSearchTerm('')
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }
  const Filter_dropdown = () => {
    setPage(1);
    //setReload(!reload);
    onFilterQuery();
  }
  const Openfilter = () => {
    setFilter(false)
    history.push('./technicians')
  }
  const Closefilter = () => {
    setFilter(true)
    // history.push('./technicians')
  }
  const CategorySelect = (val) => {
    setCatresult(val.map((n) => n.value))
  }
  const CategoryRemove = (val) => {
    setCatresult(val.map((n) => n.value));
  }
  function getCategory(ids) {
    var results = ids.map(a => a.category).join(',');
    return results;
  }
  if (!technicians) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>TECHNICIANS</h1>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                {per.includes('technician_add') ? <Link to="/technicians/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TECHNICIAN</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TECHNICIAN</Button>}
              </div>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                {filter ? <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Openfilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                  <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={14} icon="close" />FILTER</Button>{' '}
                </div> :
                  <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Closefilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                    <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="filter" />FILTER</Button>{' '}
                  </div>
                }
                <Col sm={6} style={{ padding: 0 }}>
                  <Form
                    onSubmit={onSubmitFilterkey}
                    render={({ handleSubmit, form }) => (
                      <form
                        onSubmit={async event => {
                          await handleSubmit(event)
                          form.reset()
                        }}>
                        <div className="pl-lg-4">
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Field name="search">
                                  {({ input, meta, reset }) => (
                                    <div>
                                      <Input
                                        style={{ backgroundColor: '#E3F7F7' }}
                                        placeholder="Search Technicians"
                                        value={searchterm}
                                        onKeyUp={(e) => handleKeyPress(e.target.value)}
                                        onChange={(event) => { setSearchTerm(event.target.value) }}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <div style={{ position: 'absolute', right: 10 }}>
                              <Button onClick={() => searchFilter()} style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0 }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" /></Button>
                            </div>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col >
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                  <ExportToExcel apiData={exported} fileName="technicians" />
                </div>
              </CardHeader>
              {filter ?
                <Col>
                  <Form
                    onSubmit={onSubmitFilter}
                    render={({ handleSubmit }) => (
                      <form onSubmit={handleSubmit}>
                        <Row>
                          <Col lg="4" >
                            <FormGroup >
                              <div style={{ display: 'flex' }}>
                                <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="categories"> </IcomoonReact></div>
                                <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} for="brand">Categories</Label></div>
                              </div>
                              <Field name="category" >
                                {({ input, meta, value }) => (
                                  <div>
                                    <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" onChange={(event) => { setSearchcategory(event.target.value) }} name="category" id="category" >
                                      <option value="">CHOOSE CATEGORY</option>
                                      {category && category.map(item => (
                                        <option style={{ fontWeight: 600 }} value={item._id}>{item.category}</option>
                                      ))}
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                          <Col lg="4" style={{ marginLeft: 10, marginTop: 30, paddingLeft: 30 }}>
                            <Button type="submit" onClick={() => Filter_dropdown()} style={{ backgroundColor: 'rgb(72 184 227)', color: 'white', border: 0, width: 'rem', borderRadius: 5, padding: '10px 40px 10px 40px' }}>Apply</Button>
                          </Col>
                        </Row>
                      </form>
                    )}
                  />
                </Col > : null}
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr >
                    <th >
                      <FormGroup check style={{ paddingBottom: '20px' }}>
                        <Input type="checkbox" />{' '}
                      </FormGroup>
                    </th>
                    <th scope="col">Technicians</th>
                    <th scope="col">Email</th>
                    <th scope="col" style={{ paddingLeft: 10 }}>Phone Number</th>
                    <th scope="col">Category</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {!technicians || technicians.length < 1 ? (
                    <tr>
                      <td style={{ color: '#12ACF6', textAlign: 'center', padding: 20, margin: 20 }} colSpan={11}>No Results found
                        <IcomoonReact style={{ marginLeft: 10 }} iconSet={iconSet} color="#12ACF6" size={22} icon="search" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {technicians.map((item, index) => (
                        <tr>
                          <th>
                            <FormGroup check style={{ paddingBottom: '20px' }}>
                              <Input type="checkbox" />{' '}
                            </FormGroup>
                          </th>
                          <td style={{ color: '#12ACF6', textTransform: 'capitalize' }}>{item.fullname}</td>
                          <td>{item.email}</td>
                          <td>{item.phone}</td>
                          <td>{item?.category && item.category.map((item, index) => {
                            return (
                              <li>{item.category}</li>
                            )
                          })}</td>
                          <td style={{ flexDirection: 'row', display: 'flex' }}>
                            {per.includes('technician_edit') ? <Button onClick={() => handleClickOpen(index)} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} >
                              <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="edit" />
                            </Button> : <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} >
                              <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="edit" />
                            </Button>}
                            {per.includes('technician_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })}> <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /></Button> :
                              <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /> </Button>}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal
        className="modal-dialog-centered"
        isOpen={open}
        style={{ maxWidth: '750px', width: '100%' }}
      >
        <div onClick={() => setOpen(false)} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
          <IcomoonReact iconSet={iconSet} onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(9 87 124)', paddingBottom: 20, color: 'white', paddingTop: 20 }}>EDIT TECHNICIAN</div>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setOpen(false)}
        >
          <IcomoonReact iconSet={iconSet} color="white" size={14} icon="close" />
        </button>
        <div>
          <Form
            onSubmit={onSubmit}
            validate={values => {
              const errors = {};
              function validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
              }
              function validatePhone(phone) {
                var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                return ph.test(String(phone).toLowerCase());
              }
              if (!values.fullname) {
                errors.fullname = "required";
              }
              if (!values.email) {
                errors.email = "required";
              } else if (!validateEmail(values.email)) {
                errors.email = "Enter a valid email address";
              }
              if (!values.phone) {
                errors.phone = "Required";
              } else if (!validatePhone(values.phone)) {
                errors.phone = "Enter a valid phonenumber";
              }
              return errors;
            }}
            render={({ handleSubmit, values, submitting, validating, valid }) => (
              <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                <div className="pl-lg-4">
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label for="fullname" style={{ fontSize: ' 0.8125rem' }}>Full Name</Label>
                        <Field name="fullname" initialValue={technicians[pos].fullname ? technicians[pos].fullname : null} >
                          {({ input, meta }) => (
                            <div>
                              <Input
                                type="text"
                                {...input}
                                placeholder="Enter User FullName"
                                style={{ color: 'black' }}
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    {/* <Col lg="6">
                      <FormGroup >
                        <Label style={{ fontSize: ' 0.8125rem' }} for="category">Choose Category</Label>
                        <Field name="category" >
                          {({ input, meta, value }) => (
                            <div>
                              <Input type="select" name="category" id="category" defaultValue={technicians[pos]?.category?.id || ''}
                                onChange={(e) => onChangeSelection_update(e.target.value)} style={{ color: 'black' }}>
                                {category && category.map((item, index) => {
                                  return (<option value={item.id}>{item.category}</option>)
                                })}
                              </Input>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col> */}
                    <Col lg="6">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="category">Category</Label>
                        <Field name="category">
                          {({ input, meta }) => (
                            <div>
                              <Multiselect
                                style={{ padding: 30 }}
                                showCheckbox={true}
                                placeholder="Choose Category"
                                options={editcategory}
                                displayValue="name"
                                selectedValues={editcatval}
                                onSelect={(val) => CategorySelect(val)}
                                onRemove={(val) => CategoryRemove(val)}
                                showArrow={true}

                              />
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-mail</Label>
                        <Field name="email" initialValue={technicians[pos].email ? technicians[pos].email : null} >
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="email"
                                style={{ color: 'black' }}
                                placeholder="Enter email address"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                        <Field name="phone" initialValue={technicians[pos].phone ? technicians[pos].phone : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                style={{ color: 'black' }}
                                placeholder="Enter Phone Number"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <hr className="my-4" />
                <div style={{ paddingBottom: '30px', display: 'flex', justifyContent: 'center' }}>
                  <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#09577C', border: 0, color: 'white', width: '40%', borderRadius: '10px', padding: 15 }} >
                    {loading && (<Spinner as="span" size="sm" aria-hidden="true" style={{ marginRight: 20 }} />)}
                    UPDATE</Button>{' '}
                </div>
              </form>
            )}
          />
        </div>
      </Modal>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Updated successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => setPeropen(false)} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
      <Modal isOpen={catemptyOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'red' }}>Please Fill Category Field</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={() => setCatemptyopen(false)} style={{ backgroundColor: 'rgb(219 219 147)', color: 'red', width: 60, display: 'flex', justifyContent: 'center', border: '1px solid white', margin: 20 }} type="button">
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Technicians;